// 수행평가
import Resource from '../Resource'

export default class PerformTestAnswer extends Resource {
  static ENDPOINT = '/api/test/perform/answer'

  constructor (args) {
    super()
    this.extend(args)
  }

  // 사용하지 않음
  static create (training, questions) {
    return new PerformTestAnswer({ training, questions })
  }

  mark () {
    const count = this.scores.reduce((acc, c) => { // c 유사 배열 객체
      acc += Object.keys(c).length
      return acc
    }, 0)
    const unitScore = (100 / count)
    const level = {
      상: unitScore,
      중: (unitScore * 0.7),
      하: (unitScore * 0.3)
    }
    // this.score = 0
    let score = 0
    this.scores.forEach(e => {
      Object.keys(e).forEach(s => {
        score += level[e[s]] // 유사 배열의 값 접근
      })
    })
    return Math.round(score)
  }
}
